import { render, staticRenderFns } from "./V2Downloads.vue?vue&type=template&id=4f0e2834&scoped=true&"
import script from "./V2Downloads.vue?vue&type=script&lang=js&"
export * from "./V2Downloads.vue?vue&type=script&lang=js&"
import style0 from "./V2Downloads.vue?vue&type=style&index=0&id=4f0e2834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e2834",
  null
  
)

export default component.exports